import { z } from "zod";
import { Signature } from "../enums/Signature";
import { dateSchema } from "../utils/DateSchema";
import { idSchema } from "../utils/IdSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";
import { EnrolleeSchema } from "./Enrollee";
import { ExcessLiabilityPolicySchema } from "./ExcessLiabilityPolicy";
import { GeneralLiabilityPolicySchema } from "./GeneralLiabilityPolicy";
import { ProjectSchema } from "./Project";
import { SourceSchema } from "./Source";

export const CertificateSchema = z.object({
  id: idSchema(),
  name: requiredStringSchema().max(250),
  enrollee: EnrolleeSchema.omit({ project: true, source: true }),
  project: ProjectSchema.omit({ source: true }),
  source: SourceSchema,
  effectiveDate: dateSchema(),
  expirationDate: dateSchema(),
  authorizedRepresentative: nameSchema().optional(),
  descriptionOfOperations: z.string().max(2000),
  policies: z.object({
    generalLiability: GeneralLiabilityPolicySchema.optional(),
    excessLiabilities: z.array(ExcessLiabilityPolicySchema),
  }),
  updatedDate: dateSchema().optional(),
  createdDate: dateSchema().optional(),
  renewalId: idSchema().optional(),
  signature: Signature.optional(),
});

export type Certificate = z.infer<typeof CertificateSchema>;
